export const environment = {
  production: true,
  baseUrl: "/api/",
  paymentUrl: location.origin
};



// WEBPACK FOOTER //
// ./src/environments/environment.prod.ts